/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAlertReconciliation extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAlertReconciliation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAlertReconciliation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAlertReconciliation>): BackgroundJobPayloadForPeriodicAlertReconciliation {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAlertReconciliation(), model);
        BackgroundJobPayloadForPeriodicAlertReconciliation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAlertReconciliation>): BackgroundJobPayloadForPeriodicAlertReconciliation {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAlertReconciliation.newInstance(<BackgroundJobPayloadForPeriodicAlertReconciliation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAlertReconciliation) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAlertReconciliation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAlertReconciliation): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAlertReconciliation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
